var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "40px",
    viewBox: "0 0 26 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "80E0F3A9-C023-42DC-B76A-35DB6EAE8892") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.765625,0 C15.1590308,0 19.53125,4.19733047 19.53125,9.375 C19.53125,14.5526695 15.1590308,18.75 9.765625,18.75 C4.37221924,18.75 0,14.5526695 0,9.375 C0,4.19733047 4.37221924,0 9.765625,0 Z M9.765625,1.125 C5.01942793,1.125 1.171875,4.81865081 1.171875,9.375 C1.171875,13.9313492 5.01942793,17.625 9.765625,17.625 C14.5118221,17.625 18.359375,13.9313492 18.359375,9.375 C18.359375,4.81865081 14.5118221,1.125 9.765625,1.125 Z M10.2786815,12.6386613 L10.2786815,14.0661139 L8.81783821,14.0661139 L8.81783821,12.6386613 L10.2786815,12.6386613 Z M9.91347067,4.6875 C11.8960437,4.6875 12.4177734,5.57652748 12.4177734,6.79111432 C12.4177734,7.93057208 11.9482167,8.43143263 11.2438815,9.12011589 C10.1873788,10.1343585 10.1352058,10.3096597 10.1612923,11.511725 L10.1612923,11.511725 L8.96131389,11.511725 C8.94827065,10.096794 9.0526166,9.79627764 10.2134653,8.65681988 C10.9178004,7.98065813 11.1917085,7.65509878 11.1917085,6.99145854 C11.1917085,6.29025377 10.9308437,5.7768717 9.73086526,5.7768717 C8.96131389,5.7768717 8.25697874,6.00225895 7.77437873,6.24016771 L7.77437873,6.24016771 L7.2265625,5.25096812 C7.87872468,4.93793028 8.76566524,4.6875 9.91347067,4.6875 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.EU_MVP-mockups_UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "17.4.1.0L_EU_UI_ECOM_HELP-ROUTER_MVP",
    transform: "translate(-1379.000000, -778.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons-/-FAB-/-Dependencies-/-Default",
    transform: "translate(1352.000000, 750.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Building-Blocks-/-24x24-",
    transform: "translate(28.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Fill",
    transform: "translate(2.734375, 2.625000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#102B4E",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill/Ford-white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.734375, -2.625000)",
    id: "Fill-124"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 25 0 25 24 0 24"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.c60a4df6320466fcc920981a04aaf7d3.svg";
export { ForwardRef as ReactComponent };